import { render, staticRenderFns } from "./PeopleList.vue?vue&type=template&id=0cd3fcf2&scoped=true&"
import script from "./PeopleList.vue?vue&type=script&lang=js&"
export * from "./PeopleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd3fcf2",
  null
  
)

export default component.exports